import classNames from 'classnames';
import { ChangeEvent } from 'react';
import styles from './textarea.module.scss';

type TextOnChange = (value?: string) => void;

type TextAreaProps = {
    id: string;
    inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'search';
    value?: string | null;
    maxLength?: number;
    onChange?: TextOnChange;
    onBlur?: () => void;
} & Omit<
    JSX.IntrinsicElements['textarea'],
    'defaultValue' | 'onChange' | 'onBlur' | 'value' | 'type' | 'inputMode' | 'autoComplete'
>;

const TextArea = ({
    id,
    inputMode = 'text',
    placeholder,
    value,
    maxLength = 2000,
    onChange,
    onBlur,
    className,
    ...props
}: TextAreaProps) => {
    const current = value ?? '';

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const next = event.target.value ?? null;
        onChange?.(next);
    };

    return (
        <div className={styles.container}>
            <textarea
                autoComplete="off"
                id={id}
                name={props.name ?? id}
                inputMode={inputMode}
                className={classNames('usa-textarea', className)}
                onChange={handleChange}
                onBlur={onBlur}
                placeholder={placeholder}
                value={current}
                {...props}
            />
            <div className={styles.counter}>
                <span className={current.length > maxLength ? styles.limit : ''}>{current.length}</span>/{maxLength}
            </div>
        </div>
    );
};

export { TextArea };
export type { TextAreaProps };
